import { render, staticRenderFns } from "./BasicFields.vue?vue&type=template&id=46752724&scoped=true&"
import script from "./BasicFields.vue?vue&type=script&lang=js&"
export * from "./BasicFields.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46752724",
  null
  
)

export default component.exports